
import { defineComponent, ref, computed } from "vue";
import { Module, Actions, Getters } from "@/store/enums/hosterEnums";
import { useStore } from "vuex";
import { useMessage } from "naive-ui";
import inviteInfoModel from "@/core/models/hoster/inviteInfo.interface";
import inviteMemberModel from "@/core/models/hoster/inviteMember.interface";
import inviteDateModel from "@/core/models/hoster/inviteDate.interface";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import invitePersonModel from "@/core/models/share/invitePerson.interface";

export default defineComponent({
  setup(props, context) {
    const store = useStore();
    const inviteDate = computed<Array<inviteDateModel>>(function () {
      let ori = store.getters[Module.desc + Getters.InviteDate];
      ori.forEach(function (value:inviteDateModel) {
        value.Time = value.Time.sort(function (a1, a2) {
          return a1.StartTime > a2.StartTime ? 1 : -1;
        });
      })
      return ori;
    });

    const inviteMember = computed(
      () => store.getters[Module.desc + Getters.InvitMember]
    );
    const inviteInfo = computed<inviteInfoModel>(
      () => store.getters[Module.desc + Getters.InviteInfo]
    );
    const formRef = ref<any>(null);
    const message = useMessage();
    const optionMember = inviteMember.value.map((v: invitePersonModel) => {
      // return {
      //   label: v.Name,
      //   value: v.Email
      // }
      return v.Name;
    });

    return {
      inviteDate,
      inviteInfo,
      inviteMember,
      formRef,
      size: ref("large"),
      generalOptions: ["Lab7", "Napa", "R414", "R411"].map((v) => ({
        label: v,
        value: v,
      })),
      rules: {
        EventName: {
          required: true,
          trigger: ["blur", "input"],
          message: "請輸入活動名稱",
        },
        EventContext: {
          required: true,
          trigger: ["blur", "input"],
          message: "請輸入活動內容",
        },
        Location: {
          type: "array",
          required: true,
          trigger: ["blur", "change"],
          message: "請輸入活動地點",
        },
        ReplayDealine: {
          type: "number",
          required: true,
          trigger: ["blur", "change"],
          message: "請輸入回覆截止日",
        },
      },
      handleValidateButtonClick(e: any) {
        e.preventDefault();
        formRef.value.validate((errors: any) => {
          if (!errors) {
            //message.success('Valid')
          } else {
            console.log(errors);
            //message.error('Invalid')
          }
        });
      },
      optionMember,
      dayjs
    };
  },
});
